import { BRIGHTEDGE_AUTOPILOT_GET_REQUEST } from '../actionTypes/BrightEdgeActionTypes';

export const getBrightEdgeAutopilotData = (payload) => ({
    type: BRIGHTEDGE_AUTOPILOT_GET_REQUEST,
    payload,
});

export default {
    getBrightEdgeAutopilotData,
};
